/**
 * Playback slice - manages playback state
 */

/* eslint-disable no-param-reassign, no-plusplus */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isPlaying: false,
  currentTime: 0,
};

const playbackSlice = createSlice({
  name: 'playback',
  initialState,
  reducers: {
    play: (state) => {
      state.isPlaying = true;
    },
    pause: (state) => {
      state.isPlaying = false;
    },
    togglePlayPause: (state) => {
      state.isPlaying = !state.isPlaying;
    },
    setCurrentTime: (state, action) => {
      state.currentTime = action.payload;
    },
    seek: (state, action) => {
      state.currentTime = action.payload;
    },
    reset: (state) => {
      state.isPlaying = false;
      state.currentTime = 0;
    },
  },
});

export const {
  play,
  pause,
  togglePlayPause,
  setCurrentTime,
  seek,
  reset,
} = playbackSlice.actions;

export const selectCurrentItemIndex = (state) => {
  const { currentTime } = state.playback;
  const { items } = state.timeline;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const itemEnd = item.start_time + item.duration;

    if (currentTime >= item.start_time && currentTime < itemEnd) {
      return i;
    }
  }

  return null;
};

export default playbackSlice.reducer;

